/* eslint-disable max-statements */

/**
 * Return new url for root filter saga
 * @param {action} action param
 * @returns {string} newUrl
 */
export const getNewUrlForEyeWearFilter = action => {
    const splitUrl = window.location.search.split('&');

    const newUrl = splitUrl.filter(filter => !filter.includes('eyewear_type'));
    const eyeWearFilter = splitUrl.find(filter => filter.includes('eyewear_type'));

    if (eyeWearFilter && eyeWearFilter.includes(action.payload)) {
        const updatedFilter = eyeWearFilter
            .split('=')[1]
            .split(',')
            .filter(el => !el.includes(action.payload));
        newUrl.push(updatedFilter.length === 0 ? '' : `eyewear_type=${updatedFilter.join()}`);
    } else {
        newUrl.push(`eyewear_type=${action.payload}`);
    }

    return newUrl.filter(el => el).join('&');
};
